import React, {useEffect, useState} from "react";
import {useWatch} from "react-hook-form";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {mb, p} from "@pg-design/helpers-css-strings";
import {SelectFieldControlled} from "@pg-design/react-hook-forms-utils";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {FOR_YOU_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../../../app/rp_reducer";
import {IRegionListRegion} from "../../../search/actions/fetch_search_regions_action";
import {ISearchInputRegion} from "../../../search/components/ISearchInputValue";
import {SearchInteractiveRegionsMap} from "../../../search/components/search_interactive_regions_map/SearchInteractiveRegionsMap";
import {ISearchFormValues} from "../../../search/types/ISearchFormValues";
import {SearchTab} from "../../../search/types/SearchTab";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setForYouMainRegion, setForYouRegion} from "../../state/for_you_modal_slice";
import {ForYouFormDisplayGtmEvent} from "../../tracking/for_you_forms_gtm_events";
import {ForYouDisplayActions} from "../../types/ForYouDisplayActions";
import {ForYouEventType} from "../../types/ForYouEventType";
import {SubmitHandlerType} from "../../types/SubmitHandlerType";
import {getOpenFromSimpleString} from "../../utils/get_open_from_string";
import {ForYouModalButton} from "../modal_parts/ForYouModalButton";

const mapBg = require("../../../offer/map/img/map_bg.jpg");

interface IProps {
    submitHandler: SubmitHandlerType;
    onNextStep: () => void;
    availableRegions?: IRegionListRegion[];
}

export const ForYouRegionForm = (props: IProps) => {
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues) as ISearchFormValues;
    const openFrom = useAppSelector((state) => state.forYouModal.openFrom);
    const dispatch = useAppDispatch();
    const region = useWatch({name: "region"});
    const selectedRegion = props.availableRegions?.find((city) => city.id === region?.value);
    const [mapRegions, setMapRegions] = useState<ISearchInputRegion[]>([]);
    const [values, setValues] = useState(searchFormValues);

    useEffect(() => {
        if (region) {
            dispatch(setForYouMainRegion(region.label));
        }
        const didRegionChange = mapRegions[0]?.id !== region?.value || mapRegions[0]?.parent?.id !== region?.value;
        if (didRegionChange) {
            setValues({
                ...searchFormValues,
                search: {
                    label: selectedRegion?.name || "",
                    tabType: values.search.tabType || SearchTab.Regions,
                    regions: selectedRegion ? [selectedRegion] : []
                }
            });
        }
    }, [region]);

    const onSubmit = () => {
        dispatch(setForYouRegion({regions: mapRegions, distance: values.distance || 0}));
        ForYouFormDisplayGtmEvent({event: ForYouEventType.REGION, action: ForYouDisplayActions.APPLY, region: region.label, openFrom});
        props.onNextStep();
    };

    const options = props.availableRegions?.map((region) => ({label: region.name, value: region.id}));

    return (
        <form onSubmit={props.submitHandler(onSubmit)} css={regionForm}>
            <div data-testid={FOR_YOU_TEST_IDS.CITY_SELECT_DROPDOWN}>
                <SelectFieldControlled name="region" options={options} placeholder="Wybierz miasto" isSearchable css={selectStyle} />
            </div>

            <div css={mapHolder}>
                {region.value === 0 ? (
                    <Text variant="body_copy_0" align="center" css={textStyle}>
                        Wybierz miasto.
                    </Text>
                ) : (
                    <SearchInteractiveRegionsMap
                        formValues={values}
                        defaultDistanceValue={0}
                        updateSelectedRegions={(option) => {
                            if ("regions" in option) {
                                setMapRegions(option.regions);
                            }
                            if ("distance" in option) {
                                setValues({...values, distance: option.distance});
                            }
                        }}
                        search={values.search}
                        isInModal
                        updateRegionsImmediately
                        eventSource={ForYouEventType.REGION}
                        openFromLabel={getOpenFromSimpleString(openFrom)}
                    />
                )}
            </div>

            <ForYouModalButton buttonText="Przejdź dalej" isDisabled={!mapRegions.length} showStep dataTestId={FOR_YOU_TEST_IDS.NEXT_STEP_BUTTON} />
        </form>
    );
};

const regionForm = css`
    width: 100%;
    position: relative;
    ${p(3, 1.5, 0, 1.5)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        background-color: ${getThemeVariable("colors.gray.100")};
        ${p(3, 3, 1, 3)};
    }
`;

const selectStyle = css`
    ${mb(2)};
`;

const mapHolder = css`
    min-height: 300px;
    background-image: url(${mapBg});
    background-size: cover;
    position: relative;

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${mb(2)};
    }
`;

const textStyle = css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
import React, {useEffect, useState} from "react";
import {useWatch} from "react-hook-form";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {mb, p} from "@pg-design/helpers-css-strings";
import {SelectFieldControlled} from "@pg-design/react-hook-forms-utils";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {FOR_YOU_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../../../app/rp_reducer";
import {IRegionListRegion} from "../../../search/actions/fetch_search_regions_action";
import {ISearchInputRegion} from "../../../search/components/ISearchInputValue";
import {SearchInteractiveRegionsMap} from "../../../search/components/search_interactive_regions_map/SearchInteractiveRegionsMap";
import {ISearchFormValues} from "../../../search/types/ISearchFormValues";
import {SearchTab} from "../../../search/types/SearchTab";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setForYouMainRegion, setForYouRegion} from "../../state/for_you_modal_slice";
import {ForYouFormDisplayGtmEvent} from "../../tracking/for_you_forms_gtm_events";
import {ForYouDisplayActions} from "../../types/ForYouDisplayActions";
import {ForYouEventType} from "../../types/ForYouEventType";
import {SubmitHandlerType} from "../../types/SubmitHandlerType";
import {getOpenFromSimpleString} from "../../utils/get_open_from_string";
import {ForYouModalButton} from "../modal_parts/ForYouModalButton";

const mapBg = require("../../../offer/map/img/map_bg.jpg");

interface IProps {
    submitHandler: SubmitHandlerType;
    onNextStep: () => void;
    availableRegions?: IRegionListRegion[];
}

export const ForYouRegionForm = (props: IProps) => {
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues) as ISearchFormValues;
    const openFrom = useAppSelector((state) => state.forYouModal.openFrom);
    const dispatch = useAppDispatch();
    const region = useWatch({name: "region"});
    const selectedRegion = props.availableRegions?.find((city) => city.id === region?.value);
    const [mapRegions, setMapRegions] = useState<ISearchInputRegion[]>([]);
    const [values, setValues] = useState(searchFormValues);

    useEffect(() => {
        if (region) {
            dispatch(setForYouMainRegion(region.label));
        }
        const didRegionChange = mapRegions[0]?.id !== region?.value || mapRegions[0]?.parent?.id !== region?.value;
        if (didRegionChange) {
            setValues({
                ...searchFormValues,
                search: {
                    label: selectedRegion?.name || "",
                    tabType: values.search.tabType || SearchTab.Regions,
                    regions: selectedRegion ? [selectedRegion] : []
                }
            });
        }
    }, [region]);

    const onSubmit = () => {
        dispatch(setForYouRegion({regions: mapRegions, distance: values.distance || 0}));
        ForYouFormDisplayGtmEvent({event: ForYouEventType.REGION, action: ForYouDisplayActions.APPLY, region: region.label, openFrom});
        props.onNextStep();
    };

    const options = props.availableRegions?.map((region) => ({label: region.name, value: region.id}));

    return (
        <form onSubmit={props.submitHandler(onSubmit)} css={regionForm}>
            <div data-testid={FOR_YOU_TEST_IDS.CITY_SELECT_DROPDOWN}>
                <SelectFieldControlled name="region" options={options} placeholder="Wybierz miasto" isSearchable css={selectStyle} />
            </div>

            <div css={mapHolder}>
                {region.value === 0 ? (
                    <Text variant="body_copy_0" align="center" css={textStyle}>
                        Wybierz miasto.
                    </Text>
                ) : (
                    <SearchInteractiveRegionsMap
                        formValues={values}
                        defaultDistanceValue={0}
                        updateSelectedRegions={(option) => {
                            if ("regions" in option) {
                                setMapRegions(option.regions);
                            }
                            if ("distance" in option) {
                                setValues({...values, distance: option.distance});
                            }
                        }}
                        search={values.search}
                        isInModal
                        updateRegionsImmediately
                        eventSource={ForYouEventType.REGION}
                        openFromLabel={getOpenFromSimpleString(openFrom)}
                    />
                )}
            </div>

            <ForYouModalButton buttonText="Przejdź dalej" isDisabled={!mapRegions.length} showStep dataTestId={FOR_YOU_TEST_IDS.NEXT_STEP_BUTTON} />
        </form>
    );
};

const regionForm = css`
    width: 100%;
    position: relative;
    ${p(3, 1.5, 0, 1.5)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        background-color: ${getThemeVariable("colors.gray.100")};
        ${p(3, 3, 1, 3)};
    }
`;

const selectStyle = css`
    ${mb(2)};
`;

const mapHolder = css`
    min-height: 300px;
    background-image: url(${mapBg});
    background-size: cover;
    position: relative;

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${mb(2)};
    }
`;

const textStyle = css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
